import { useState, useEffect } from "react";

const PdfPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenPdfPopup");

    if (!hasSeenPopup) {
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem("hasSeenPdfPopup", "true");
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.popupBox}>
        <div style={styles.popupHeader}>
          <h2 style={styles.headerTitle}>Kolkata Municipal Corporation</h2>

          <button
            type="button"
            style={styles.closeButton}
            onClick={handleClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <div style={styles.pdfContainer}>
          <iframe
            src="/Average_AQI_Hourly_AQI_for_Kolkata.pdf#toolbar=0"
            title="PDF Viewer"
            style={styles.iframe}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999999,
    padding: "20px",
    boxSizing: "border-box",
  },

  popupBox: {
    position: "relative",
    width: "85%",
    maxWidth: "650px",
    height: "85vh",
    maxHeight: "850px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    overflow: "hidden",
  },

  popupHeader: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "15px 20px",
    borderBottom: "1px solid #eee",
  },

  headerTitle: {
    margin: 0,
    fontSize: "1.25rem",
    color: "#333",
    fontWeight: "600",
  },

  closeButton: {
    background: "none",
    border: "none",
    fontSize: "1.5rem",
    color: "#666",
    cursor: "pointer",
    padding: "5px 10px",
    borderRadius: "4px",
  },

  pdfContainer: {
    flex: 1,
    minHeight: 0,
    width: "100%",
    overflow: "hidden",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },
};

export default PdfPopup;
